import React from 'react';
import Button from './Button';

export interface FormActionsProps {
  onCancel: () => void;
  submitText?: string;
  cancelText?: string;
  isSubmitting?: boolean;
  submitDisabled?: boolean;
  className?: string;
}

const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  submitText = 'Save',
  cancelText = 'Cancel',
  isSubmitting = false,
  submitDisabled = false,
  className = '',
}) => {
  return (
    <div className={`mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-3 ${className}`}>
      <Button
        type="submit"
        variant="primary"
        disabled={isSubmitting || submitDisabled}
        loading={isSubmitting}
        className="w-full sm:w-auto mobile-btn mobile-btn-primary"
      >
        {submitText}
      </Button>
      <Button
        type="button"
        variant="secondary"
        onClick={onCancel}
        disabled={isSubmitting}
        className="w-full sm:w-auto mobile-btn mobile-btn-secondary"
      >
        {cancelText}
      </Button>
    </div>
  );
};

export default FormActions;
